import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import { useDataGridSettings } from "@/components/DataGridSettingsProvider";
import { useViewContext } from "@/components/ViewProvider";
import { useResetViewOverride } from "@/hooks/views/useResetViewOverride";

export function ResetViewOverrideButton() {
  const { t } = useTranslation();
  const { pageType } = useDataGridSettings();
  const { selectedView, hasOverride } = useViewContext();
  const { resetOverride } = useResetViewOverride(pageType);

  if (!selectedView || !hasOverride) return null;

  return (
    <Button
      size="small"
      startIcon={<RestartAltIcon />}
      onClick={() => resetOverride(selectedView.id)}
    >
      {t("views.resetToAdmin")}
    </Button>
  );
}
